export const durationOptionsValues: string[] = [
  '00:00:00',
  '00:05:00',
  '00:10:00',
  '00:15:00',
  '00:30:00',
  '01:00:00',
  '02:00:00',
  '03:00:00',
  '04:00:00',
  '05:00:00',
  '06:00:00',
  '07:00:00',
  '08:00:00',
  '09:00:00',
  '10:00:00',
  '11:00:00',
  '12:00:00',
  '18:00:00',
  '1.00:00:00',
  '2.00:00:00',
  '3.00:00:00',
  '4.00:00:00',
  '5.00:00:00',
  '6.00:00:00',
  '7.00:00:00',
  '14.00:00:00',
  '21.00:00:00',
  '28.00:00:00',
  '42.00:00:00',
  '56.00:00:00',
]
